<ckeditor
  [editor]="ckEditor"
  [data]="value"
  (ready)="onReady($event)"
  (change)="ckEditChange($event)"
  id="classic-editor">
</ckeditor>
